/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Relationship/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personFromPersonRelationships0TypeValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'from_person_relationships[0].type',
format: fromFormat.toCapitalisedCamelCase,
})
let personFromPersonRelationships0RoleValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'from_person_relationships[0].role',
format: fromFormat.toCapitalisedCamelCase,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="person.from_person_relationships[0].type"
 format="/Data/format.js toCapitalisedCamelCase"
 text={personFromPersonRelationships0TypeValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="·"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="person.from_person_relationships[0].role"
 format="/Data/format.js toCapitalisedCamelCase"
 text={personFromPersonRelationships0RoleValueData}
/>
</div>
{children}
</React.Fragment>)
}